import React, { memo } from 'react';

const WidgetsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M16.563 18.741v13.25h13.25v-13.25h-13.25zM0 31.991h13.25v-13.25h-13.25v13.25zM0 2.178v13.25h13.25v-13.25h-13.25zM22.625 0.009l-9.375 9.358 9.375 9.375 9.375-9.375-9.375-9.358z"
        />
    </svg>
);

export default memo(WidgetsIcon);
